<app-page-header subtitle="OrderDirect Facturen"> </app-page-header>

<div class="text-container">
    <div class="row mb-3">
        <div class="col-24">
            <div class="d-flex justify-content-between align-items-center flex-wrap gap-2">
                <div class="d-flex gap-2 align-items-center flex-wrap">
                    <mat-form-field class="mb-0" appearance="outline" style="width: 300px">
                        <mat-label>Zoeken...</mat-label>
                        <input [formControl]="fcSearch" matInput placeholder="Bonnummer, debiteur, AFAS order..." />
                        @if (fcSearch.value) {
                            <button (click)="fcSearch.setValue('')" matSuffix mat-icon-button>
                                <i class="fas fa-times"></i>
                            </button>
                        }
                    </mat-form-field>
                    <button (click)="triggerSync()" mat-raised-button color="primary">
                        <i class="fas fa-sync me-1"></i> 1. Ophalen uit OrderDirect
                    </button>
                    <button (click)="sendAllToAfas()" mat-raised-button color="primary">
                        <i class="fas fa-paper-plane me-1"></i> 2. Verstuur naar AFAS
                    </button>
                </div>
                <mat-button-toggle-group [value]="statusFilter" (change)="filterByStatus($event.value)">
                    <mat-button-toggle [value]="null">Alle</mat-button-toggle>
                    <mat-button-toggle value="new">Nieuw</mat-button-toggle>
                    <mat-button-toggle value="pending">In behandeling</mat-button-toggle>
                    <mat-button-toggle value="completed">Voltooid</mat-button-toggle>
                    <mat-button-toggle value="failed">Mislukt</mat-button-toggle>
                </mat-button-toggle-group>
            </div>
        </div>
    </div>

    @if (loading) {
        <div class="text-center">
            <div class="spinner-border" role="status">
                <span class="visually-hidden">Laden...</span>
            </div>
        </div>
    }

    @if (!loading && invoices.length === 0) {
        <div class="alert alert-info">Geen facturen gevonden.</div>
    }

    @if (!loading && invoices.length > 0) {
        <div class="row">
            <div class="col-md-24">
                <div class="table-responsive">
                    <table class="table table-hover table-striped">
                        <thead>
                            <tr>
                                <th>Bonnummer</th>
                                <th width="140">Datum</th>
                                <th>Debiteur</th>
                                <th>Naam</th>
                                <th class="text-end">Prijs</th>
                                <th class="text-end">AFAS bedrag</th>
                                <th>AFAS Order</th>
                                <th>Status</th>
                                <th>Foutmelding</th>
                                <th width="190">Aangemaakt</th>
                                <th>Acties</th>
                            </tr>
                        </thead>
                        <tbody>
                            @for (invoice of invoices; track invoice.id) {
                                @let afasTotal = getAfasTotal(invoice);
                                <tr class="clickable">
                                    <td>
                                        <a [routerLink]="['/orderdirect-facturen', invoice.id]">{{
                                            invoice.od_bon_nr
                                        }}</a>
                                    </td>
                                    <td>{{ invoice.od_bon_datum | date: 'EEE d MMM yyyy' }}</td>
                                    <td>{{ invoice.od_deb_nr }}</td>
                                    <td>{{ invoice.od_deb_naam }}</td>
                                    <td class="text-end">
                                        {{ invoice.od_prijs_verk | currency: 'EUR' : 'symbol' : '1.2-2' }}
                                    </td>
                                    <td
                                        class="text-end"
                                        [class.bg-success]="
                                            afasTotal != null && afasMatchesSellingPrice(invoice, afasTotal)
                                        "
                                        [class.bg-danger]="
                                            afasTotal != null && !afasMatchesSellingPrice(invoice, afasTotal)
                                        "
                                        [class.text-white]="afasTotal != null">
                                        @if (afasTotal != null) {
                                            {{ afasTotal | currency: 'EUR' : 'symbol' : '1.2-2' }}
                                        } @else {
                                            <span class="text-muted">-</span>
                                        }
                                    </td>

                                    <td>
                                        @if (invoice.afas_liin) {
                                            <span class="badge bg-success">{{ invoice.afas_liin }}</span>
                                        } @else {
                                            <span class="text-muted">-</span>
                                        }
                                    </td>
                                    <td>
                                        <span
                                            class="badge"
                                            [ngClass]="getStatusClass(invoice | orderdirectInvoiceStatus)">
                                            {{ getStatusLabel(invoice | orderdirectInvoiceStatus) }}
                                        </span>
                                    </td>
                                    <td>
                                        @if (invoice.exception) {
                                            <div
                                                class="text-danger"
                                                style="font-size: 0.9rem; max-width: calc(100vw - 1400px)">
                                                {{ invoice.exception }}
                                            </div>
                                        } @else {
                                            <span class="text-muted">-</span>
                                        }
                                    </td>
                                    <td>{{ invoice.created_at | date: 'EEE d MMM yyyy HH:mm' }}</td>
                                    <td>
                                        @if (canSendToAfas(invoice)) {
                                            <button
                                                (click)="sendToAfas(invoice, $event)"
                                                mat-stroked-button
                                                color="primary">
                                                <i class="fas fa-paper-plane me-1"></i> Naar AFAS
                                            </button>
                                        }
                                    </td>
                                </tr>
                            }
                        </tbody>
                    </table>
                </div>

                <!-- Material Paginator -->
                <mat-paginator
                    class="mt-3"
                    [length]="totalItems"
                    [pageSize]="pageSize"
                    [pageIndex]="pageIndex"
                    [pageSizeOptions]="pageSizeOptions"
                    [showFirstLastButtons]="true"
                    (page)="onPageChange($event)">
                </mat-paginator>
            </div>
        </div>
    }
</div>
